import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin-layout"
export default class extends Controller {
  static targets = [
    "sidebar",
    "hamburgerLine1",
    "hamburgerLine2",
    "hamburgerLine3",
    "hamburgerCross1",
    "hamburgerCross2"
  ]
  static values = {
    sidebarToggle: { type: Boolean, default: false }
  }

  connect() {
    // Restore sidebar state from sessionStorage on mobile
    if (window.innerWidth < 1024) {
      const savedState = sessionStorage.getItem('sidebarOpen')
      if (savedState === 'true') {
        this.sidebarToggleValue = true
      }
    }
    this.updateSidebarState()
  }

  toggleSidebar(event) {
    event?.preventDefault()
    event?.stopPropagation()
    this.sidebarToggleValue = !this.sidebarToggleValue
    this.updateSidebarState()
    
    // Save sidebar state to sessionStorage on mobile
    if (window.innerWidth < 1024) {
      sessionStorage.setItem('sidebarOpen', this.sidebarToggleValue.toString())
    }
  }

  closeSidebarOnOutsideClick(event) {
    // Only close on mobile (when sidebar is absolutely positioned)
    if (window.innerWidth >= 1024) return

    // Don't close if clicking on toggle button
    if (event.target.closest('[data-action*="toggleSidebar"]')) return
    
    // Don't close if clicking inside sidebar
    if (this.sidebarTarget.contains(event.target)) return

    if (this.sidebarToggleValue) {
      this.sidebarToggleValue = false
      this.updateSidebarState()
      
      // Update sessionStorage when closing
      sessionStorage.setItem('sidebarOpen', 'false')
    }
  }

  updateSidebarState() {
    if (this.sidebarToggleValue) {
      // Sidebar is open
      this.sidebarTarget.classList.remove('-translate-x-full')
      this.sidebarTarget.classList.add('translate-x-0')

      // Update hamburger icon to show X
      if (this.hasHamburgerLine1Target) {
        this.hamburgerLine1Target.classList.remove('!w-full', 'delay-300')
        this.hamburgerLine1Target.classList.add('w-0', 'delay-[0]')
        this.hamburgerLine2Target.classList.remove('!w-full', 'delay-400')
        this.hamburgerLine2Target.classList.add('w-0', 'delay-150')
        this.hamburgerLine3Target.classList.remove('!w-full', 'delay-500')
        this.hamburgerLine3Target.classList.add('w-0', 'delay-200')

        this.hamburgerCross1Target.classList.remove('!h-0', 'delay-[0]')
        this.hamburgerCross1Target.classList.add('h-full', 'delay-300')
        this.hamburgerCross2Target.classList.remove('!h-0', 'dealy-200')
        this.hamburgerCross2Target.classList.add('h-0.5', 'delay-400')
      }
    } else {
      // Sidebar is closed
      this.sidebarTarget.classList.remove('translate-x-0')
      this.sidebarTarget.classList.add('-translate-x-full')

      // Update hamburger icon to show lines
      if (this.hasHamburgerLine1Target) {
        this.hamburgerLine1Target.classList.remove('w-0', 'delay-[0]')
        this.hamburgerLine1Target.classList.add('!w-full', 'delay-300')
        this.hamburgerLine2Target.classList.remove('w-0', 'delay-150')
        this.hamburgerLine2Target.classList.add('!w-full', 'delay-400')
        this.hamburgerLine3Target.classList.remove('w-0', 'delay-200')
        this.hamburgerLine3Target.classList.add('!w-full', 'delay-500')

        this.hamburgerCross1Target.classList.remove('h-full', 'delay-300')
        this.hamburgerCross1Target.classList.add('!h-0', 'delay-[0]')
        this.hamburgerCross2Target.classList.remove('h-0.5', 'delay-400')
        this.hamburgerCross2Target.classList.add('!h-0', 'dealy-200')
      }
    }
  }
}
